import React, { useCallback, useState, useEffect } from 'react'
import { Spin } from 'antd'
import Radio from 'meinian-package/src/baseComponent/radio'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import cloneDeep from 'lodash/cloneDeep'
import { request } from 'meinian-package/src/utils'
import { useUpdate } from 'ahooks'
import { convert } from '../../common/convert'
import setFolder from '../useFunModal/setFolder'
import './index.less'

export const FolderTreeSample = ({ onCreateComplete, ...otherProps }) => {
  const onUpdate = useUpdate()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    try {
      const result = await request.post('/zhikuan/mn/sample/folder/sample-folder-tree', { rankStatus: 'addSample' })
      setData(convert(result, 'folderName', 'id', 'childs'))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const onCreate = (curData, _parentId, resultData) => {
    const _tempObj = cloneDeep(resultData)
    _tempObj.label = resultData.folderName
    _tempObj.value = resultData.id
    _tempObj.children = resultData.childs
    _tempObj.children = convert(resultData.childs)
    if (!_parentId) { // 不存在为根目录 存在子目录
      data.unshift(_tempObj)
    } else {
      const curParentData = data.find(item => item.id === _parentId)
      curParentData.children.unshift(_tempObj)
    }
    onCreateComplete?.(curData, _parentId, resultData)
    onUpdate()
  }
  return <FolderTree
    data={data}
    onCreate={onCreate}
    loading={loading}
    {...otherProps}
  />
}

export const FolderTreeWrap = ({ ...otherProps }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    try {
      const result = await request.post('/zhikuan/mn/sample/folder/sample-folder-tree', { rankStatus: 'addSample' })
      setData(convert(result, 'folderName', 'id', 'childs'))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  return <FolderTree
    data={data}
    loading={loading}
    {...otherProps}
  />
}

// hiddenRoot 是否展示根目录
export const FolderTree = ({
  onChange,
  onCreate,
  hiddenRoot = true,
  type,
  data = [],
  value = null,
  createFolderAuth = true,
  disabled = false,
  contentHeight,
  loading,
}) => {
  const [parentHiddenVal, setParentHiddenVal] = useState()

  const isFolder = type === 'folder' // 是否是移动文件夹

  useEffect(() => {
    const curItem = data.find(item => {
      if (item.children.some(i => i.id === value)) {
        return true
      }
      return false
    })
    if (curItem) {
      setParentHiddenVal(curItem.id)
    }
  }, [data])

  const _onChange = (curData, val) => {
    onChange?.(curData, val)
  }
  const _onClick = (curData, val) => {
    if (parentHiddenVal === val) {
      setParentHiddenVal(null)
    } else {
      setParentHiddenVal(val)
    }
  }

  const _onCreate = (curData, _parentId) => {
    setFolder({
      value: { parentId: _parentId },
      title: curData ? '新建子文件夹' : '新建文件夹',
      onOk: (folderVal) => {
        onCreate?.(curData, _parentId, folderVal)
      }
    })
  }

  const _height = useCallback((item) => {
    if (parentHiddenVal === item.value) {
      if (item?.children?.length) {
        if (createFolderAuth) {
          return Number(item?.children?.length) * 32 + 32
        }
        return Number(item?.children?.length) * 32
      }
      return 32
    }
    return 0
  }, [parentHiddenVal])

  const showIcon = (item) => {
    if (!isFolder) {
      if (!createFolderAuth && item.children.length === 0) {
        return false
      }
      return true
    }
    return false
  }

  const renderDom = () => {
    if (!loading) {
      if (data.length) {
        return data.map(item => <FolderTreeItem
          childrenHidden={parentHiddenVal === item.value}
          key={item.value}
          data={item}
          value={value}
          showIcon={showIcon(item)}
          onChange={_onChange}
          disabled={disabled}
          onClick={(...arg) => {
            if ((!createFolderAuth && item.children.length === 0) || isFolder) {
              return
            }
            _onClick(...arg)
          }}
        >
          <div
            className={classNames('mn-folder-tree-item-child')}
            style={{ height: _height(item) }}
          >
            {!isFolder && item?.children?.map(chidItem => <FolderTreeItem
              key={chidItem.value}
              data={chidItem}
              value={value}
              onChange={_onChange}
              disabled={disabled}
            />)}
            {
              !isFolder && createFolderAuth && <FolderTreeItemCreate onClick={() => _onCreate(item, item.value)} />
            }
          </div>
        </FolderTreeItem>)
      }
      return <div className="mn-folder-tree-empty" onClick={() => _onCreate(null, null)}>
        <div style={{ textAlign: 'center' }}>
          <Icon type="m-xinjianlingganji" className="mn-folder-tree-empty-icon" />
          <div className="mn-folder-tree-empty-text">暂无样衣文件夹，点击新建文件夹</div>
        </div>
      </div>
    }
    return <Spin spinning />
  }

  return <div className="mn-folder-tree">
    <div style={{ flex: `${contentHeight ? 'unset' : '1'}`, padding: '8px', overflow: 'auto', maxHeight: contentHeight }}>
      {hiddenRoot && <FolderTreeItem data={{ label: '根目录', value: -1 }} value={value} onChange={_onChange} disabled={disabled} />}
      {
        renderDom()
      }
    </div>
    {
      createFolderAuth && <FolderTreeItemFooterCreate onClick={() => _onCreate(null, null)} />
    }
  </div>
}

const FolderTreeItem = ({
  data = {},
  label = '',
  showIcon,
  value, onChange, children, childrenHidden, onClick, disabled
}) => {
  const _onClick = (e) => {
    e.stopPropagation()
    children && onClick?.(data, data.value)
  }
  return <div className="mn-folder-tree-item-wrap" style={{ cursor: children && 'pointer' }}>
    <div className="mn-folder-tree-item">
      <div className="mn-folder-tree-item-label" onClick={_onClick}>
        <div className="mn-folder-tree-item-label-title text-overflow">{data.label || label}</div>
        {showIcon && children && <Icon type={`${childrenHidden ? 'm-Vxing_shang' : 'm-Vxing_xia'}`} className="mn-folder-tree-item-label-icon" />}
        {
            data?.addSampleFlag ? <span className="mn-folder-tree-last-add-label">上次加入</span> : null
        }
      </div>
      <Radio checked={data.value === value} onChange={() => onChange(data, data.value)} disabled={disabled} />
    </div>
    {children}
  </div>
}

const FolderTreeItemCreate = ({ onClick }) => {
  return <div
    className="mn-folder-tree-item-create"
    onClick={onClick}
  >
    <Icon type="m-tianjia" className="mn-folder-tree-item-create-icon" />新建子文件夹并加入
  </div>
}

const FolderTreeItemFooterCreate = ({ onClick }) => {
  return <div
    className="mn-folder-tree-item-footer-create"
    onClick={onClick}
  >
    <Icon type="m-tianjia_miaobian" className="mn-folder-tree-item-footer-create-icon" />新建文件夹
  </div>
}
